
import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IWsrCardProps,
  IWsrCardMapperProps,
  IWsrCardControllerProps,
  IWsrCardStateValues,
} from '../../../components/WsrCard/WsrCard.props';

export default withCompController<
  IWsrCardMapperProps,
  IWsrCardControllerProps,
  IWsrCardProps,
  IWsrCardStateValues
>(({ mapperProps, controllerUtils, stateValues }) => {
  const { editorType } = stateValues
  return {
    ...mapperProps,
    editorType,
    updateComponentPropsInViewer: props => {
      controllerUtils.updateProps(props);
    }
  }
});
